import React from 'react';
import Link from 'next/link';
import has from 'lodash/has';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { BlogCategoryListStyles } from './BlogListComponentStyles';

const BlogCategoryList = props => {
  const { query } = useRouter();
  const hasCategory = has(query, 'category');

  const categories = props.categories.filter(c => c.id !== 1);

  return (
    <BlogCategoryListStyles>
      <div className="categories">
        <ul className="categories__list">
          {hasCategory ? (
            <li>
              <Link href="/blog">
                <a>View All</a>
              </Link>
            </li>
          ) : null}
          {categories.map(c => (
            <li key={c.id}>
              <Link href="/blog/topics/[category]" as={`/blog/topics/${c.slug}`}>
                <a className={query.category === c.slug ? 'active' : ''}>{c.name}</a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </BlogCategoryListStyles>
  );
};

BlogCategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      count: PropTypes.number,
      description: PropTypes.string,
      link: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
      taxonomy: PropTypes.string,
      parent: PropTypes.number,
      meta: PropTypes.array,
      acf: PropTypes.array,
      _links: PropTypes.object,
    })
  ),
};

export default BlogCategoryList;
